module.exports = __webpack_public_path__ + "static/media/img-axum-product-3.73cfa9db.png";